// Pesquisa das reservas no Dashboard: sem acentos, sem maiúsculas e, para matrícula, telefone,
// datas e id, sem separadores ("aa00bb" encontra "AA-00-BB", "04/11" encontra "04-11-2026").

const semAcentos = (texto) => String(texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

const compacto = (texto) => semAcentos(texto).replace(/[^0-9a-z]/g, '');

// Mínimo de caracteres para ir pesquisar ao servidor quando não há resultados locais
export const MIN_CARACTERES_PESQUISA_SERVIDOR = 3;

export const pesquisaValidaParaServidor = (pesquisa) => pesquisa.trim().length >= MIN_CARACTERES_PESQUISA_SERVIDOR;

export function correspondePesquisa(reserva, pesquisa) {
    const texto = semAcentos(pesquisa).trim();
    if (!texto) {
        return true;
    }

    const acf = reserva.acf || {};
    const modelo = acf.modelo !== 'a:0:{}' ? acf.modelo : '';
    const textoLivre = semAcentos(`${acf.primeiro_nome} ${acf.ultimo_nome} ${acf.marca} ${modelo}`);
    if (textoLivre.includes(texto)) {
        return true;
    }

    const textoCompacto = compacto(pesquisa);
    if (!textoCompacto) {
        return false;
    }
    return [reserva.ID, acf.matricula, acf.telemovel, acf.dia_de_entrada, acf.dia_de_saida]
        .some(campo => compacto(campo).includes(textoCompacto));
}
